var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLibra(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 26,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.864 16.863h-1.545c-1.59-1.59-2.605-3.753-2.605-6.137 0-4.768 3.885-8.653 8.653-8.653 4.769 0 8.654 3.885 8.654 8.653a8.53 8.53 0 0 1-2.605 6.137h-1.413v1.766h15.364v-1.766H28.933a10.502 10.502 0 0 0 1.986-6.137C30.92 4.898 26.195.174 20.367.174 14.54.174 9.815 4.898 9.815 10.726c0 2.296.751 4.415 1.987 6.137H.544v1.766h15.364v-1.766h-.044zM40.5 24.06H.5v1.766h40V24.06z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibra);
export default __webpack_public_path__ + "static/media/libra.a2d7cf109c8fa652b1ac74d4052dddc9.svg";
export { ForwardRef as ReactComponent };